import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../assets/styles/components/instrument/market-add-group-dialog-mobile.scss'
import { userActions } from '@/actions/user';
import { Icons } from '@/configurations';
import { SERVICES_RESP } from '@/configurations';
import Tips from '@/components/Tips/Tips';


class MarketAddGroupDialog extends Component{
    constructor(props){
        super(props)
        this.state={
            isLoadingConfirm:false,
            errorMessage:""
        }
    }
    
    render(){
        const { isLoadingConfirm , errorMessage} = this.state
        const { language } = this.props
        return(
            <div className='add-group-contanier'>
                 {errorMessage && <Tips isNoBgColor>{language[errorMessage] ?? errorMessage}</Tips>}
                <input autoComplete='off' placeholder={language.mobile_fill_watchlist_name} ref={e => this.angInputRef = e}>
            
                </input>
                <div className='confirm-btn' onClick={this.handleAddWatchlistGroup}>{isLoadingConfirm ? <Icons.Loading /> :language.common_button_submit}</div>
            </div>
        )
    }

    handleAddWatchlistGroup=()=> {
        const newTitle = this.angInputRef.value
        if(this.state.isLoadingConfirm) return
        if (newTitle) {
            this.setState({ isLoadingConfirm: true })
            const params = {
                title: newTitle,
                ids: '',
                template: 'watchlist2'
            }
            this.props.addNewWatchlist(params, res => {
                this.handleResponse(res)
            })
        }
    }

    handleResponse = (res, message) => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
            const { userInfo } = this.props
            this.props.getWatchlist({ uuid: userInfo.id }, response => {
                this.setState({ isLoadingConfirm: false, showInput: false }, () => {
                    this.angInputRef.value = ''
                })
            })
        } else {
            const errorMessage = res?.result ?? ''
            this.setState({ errorMessage,  isLoadingConfirm: false })
        }
    }

    componentDidMount(){
        setTimeout(() => {
            this.angInputRef.focus()
        }, 500);
    }
}



export default connect(
    state => ({
        language: state.app.language,
        watchlist: state.user.watchlist,
        userInfo: state.user.userInfo,
        theme: state.app.theme,
    }),
    dispatch => ({
        addNewWatchlist: (p, c) => dispatch(userActions.addNewWatchlistAction(p, c)),
        manageWatchList: (p, c) => dispatch(userActions.manageWatchlistAction(p, c)),
        getWatchlist: (p, c) => dispatch(userActions.getInstrumentWatchlistAction(p, c)),
    }))(MarketAddGroupDialog)